<template>
  <div class="tnc">
    <h2>{{ $t("RPAS WILCO Flight Review Terms and Conditions") }}</h2>
    <p>{{ $t("Last Updated:") }} 2024-11-01</p>

    <h6>{{ $t("1 Rescheduling Policy:") }}</h6>
    <p>
      {{
        $t(
          "Clients may reschedule their session without additional cost, provided they notify the assigned flight reviewer at least 48 hours before the scheduled session."
        )
      }}
    </p>
    <p>
      {{
        $t(
          "Rescheduling requests made less than 48 hours prior to the session cannot be accommodated."
        )
      }}
    </p>
    <p>
      {{
        $t(
          "Clients are not permitted to cancel their session; they can only reschedule as per the rescheduling policy."
        )
      }}
    </p>
    <p>
      {{
        $t(
          "In the event of a no-show or failure to reschedule in time, the session is forfeited without a refund."
        )
      }}
    </p>

    <h6>{{ $t("2 Pro Subscription Benefit:") }}</h6>
    <p>
      {{
        $t(
          "Upon completing a flight review booking, clients will receive a one-year Pro subscription to RPAS WILCO services."
        )
      }}
    </p>

    <h6>{{ $t("3 Flight Reviewer Cancellation:") }}</h6>
    <p>
      {{
        $t(
          "Clients should be aware that flight reviewers may cancel sessions up to 3 hours before the scheduled time due to weather conditions or other unforeseen circumstances."
        )
      }}
    </p>

    <h6>{{ $t("4 Changes to Terms and Conditions:") }}</h6>
    <p>
      {{
        $t(
          "RPAS WILCO reserves the right to modify these terms and conditions at any time. Changes will be effective immediately upon posting on our website."
        )
      }}
    </p>

    <h6>{{ $t("5 Contact Information:") }}</h6>
    <p>
      {{ $t("For queries or concerns, please contact contact@rpaswilco.com.") }}
    </p>
  </div>
</template>
<script>
export default {
  name: "tnc"
};
</script>
<style lang="scss">
.tnc {
  padding: 20px;
  background-color: #ddd;
}
</style>
